import React from "react";
import T from "prop-types";
import { getFormValues } from "redux-form";
import { connect } from "react-redux";
import {
  OUTGOING_AWB_NUMBER,
  SHIP_MULTIPLE_ITEM_IDS
} from "MODULES/Shipping/constants";
import {
  BIO_HAZMAT,
  COUNTRY_OF_MFG,
  HAZMAT,
  HEIGHT,
  LENGTH,
  NET_HEIGHT,
  NET_LENGTH,
  NET_WEIGHT,
  NET_WEIGHT_OZ,
  NET_WEIGHT_UNIT,
  NET_WIDTH,
  WEIGHT,
  WEIGHT_UNIT,
  WIDTH
} from "MODULES/parts/constants";
import pojo from "LIB/pojos";
import { ATTACHMENTS, SHIPPING_METHOD, TYPE } from "APP_ROOT/constants";
import { save } from "MODULES/Shipping/actions";
import {
  CUSTOMER_TO_PROVIDE_OWN_PAPERWORK,
  DISCREET,
  PICTURES_REQUIRED,
  SPECIAL_INSTRUCTIONS
} from "MODULES/SalesOrders/constants";
import { EXTERNAL_NOTE } from "MODULES/PurchaseOrders/constants";

const Save = props => {
  const formData = pojo(props.values).pick(
    ATTACHMENTS,
    BIO_HAZMAT,
    COUNTRY_OF_MFG,
    CUSTOMER_TO_PROVIDE_OWN_PAPERWORK,
    DISCREET,
    EXTERNAL_NOTE,
    HAZMAT,
    OUTGOING_AWB_NUMBER,
    HEIGHT,
    LENGTH,
    WEIGHT,
    WEIGHT_UNIT,
    WIDTH,
    NET_WEIGHT,
    NET_LENGTH,
    NET_WIDTH,
    NET_HEIGHT,
    NET_WEIGHT_OZ,
    NET_WEIGHT_UNIT,
    PICTURES_REQUIRED,
    SHIPPING_METHOD,
    SHIP_MULTIPLE_ITEM_IDS,
    SPECIAL_INSTRUCTIONS
  );

  formData[TYPE] = props.values.reference_record_line_item_type;

  return (
    <button
      disabled={props.submitting}
      className="btn btn-primary"
      style={{ paddingLeft: "5px", paddingRight: "5px" }}
      onClick={e => {
        e.preventDefault();

        props
          .save(props.values.reference_record_line_item_id, formData)
          .then(() => {
            props.close();
          });
      }}
    >
      {props.submitting ? (
        <i className="fa fa-cog fa-spin fa-fw fa-lg" />
      ) : (
        "Save"
      )}
    </button>
  );
};

export default connect(
  (state, ownProps) => ({
    values: getFormValues(ownProps.form)(state)
  }),
  dispatch => ({
    save: (id, data) => dispatch(save(id, data))
  })
)(Save);

Save.propTypes = {
  close: T.func.isRequired,
  submitting: T.bool.isRequired,
  values: T.shape({
    reference_record_line_item_type: T.string.isRequired,
    reference_record_line_item_id: T.number.isRequired
  })
};



// WEBPACK FOOTER //
// ./app/modules/Shipping/components/Dashboard/Create/Save.jsx